// extracted by mini-css-extract-plugin
module.exports = {"videoTitle":"button-video-module--videoTitle--17wO5","buttonSeeVideo":"button-video-module--buttonSeeVideo--3GrVM"};